exports = module.exports = require("../../../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.slideDom[data-v-1cf09ee6] {\n  /* position: absolute; */\n  height: 100%;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 0;\n  /* margin: auto; */\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.28.11@css-loader?{"minimize":false,"sourceMap":false}!./~/_vue-loader@11.3.4@vue-loader/lib/style-compiler?{"id":"data-v-1cf09ee6","scoped":true,"hasInlineConfig":true}!./~/_less-loader@4.0.5@less-loader/dist/cjs.js?{"sourceMap":false}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=styles&index=0!./src/components/composite/slide/src/slide.vue
// module id = 708
// module chunks = 1